import { render } from "./EmailHeader.vue?vue&type=template&id=287d4260&scoped=true&ts=true"
import script from "./EmailHeader.vue?vue&type=script&lang=ts"
export * from "./EmailHeader.vue?vue&type=script&lang=ts"

import "./EmailHeader.vue?vue&type=style&index=0&id=287d4260&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287d4260"]])

export default __exports__